import * as React from 'react';
import s from '../RequestCall.scss';
import { SuccsessMessage } from './SuccsessMessage';
import X from 'wix-ui-icons-common/X';
import { Modal, CloseButton, Loader } from '@wix/design-system';
import { EnterpriseModalClickSource } from 'services/BiLogger/BiLoggerTypes';

const ContactDetails = React.lazy(
  () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "contactDetails" */ '../lazy/ContactDetails'
    ),
);

interface RequestCallModalProps {
  isOpen: boolean;
  clickSource?: EnterpriseModalClickSource;
  onCancelClick(): void;
}

export const RequestCallModal: React.FC<RequestCallModalProps> = ({
  isOpen,
  clickSource,
  onCancelClick,
}) => {
  const [shouldShowSuccsessMessage, showSuccsessMessage] =
    React.useState(false);
  const closeModal = () => {
    onCancelClick();
    setTimeout(() => showSuccsessMessage(false), 100);
  };
  return (
    <Modal
      isOpen={isOpen}
      dataHook='request-call-modal'
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
    >
      <div className={s.modalWrapper}>
        <CloseButton
          onClick={closeModal}
          size='medium'
          skin='dark'
          className={s.closeModalIcon}
        >
          <X width='30px' height='30px' />
        </CloseButton>
        {shouldShowSuccsessMessage ? (
          <SuccsessMessage onDismissClick={closeModal} />
        ) : (
          <React.Suspense
            fallback={
              <div className={s.contactFormLoader}>
                <Loader />
              </div>
            }
          >
            <ContactDetails
              clickSource={clickSource}
              onCancelClick={closeModal}
              showSuccsessMessage={showSuccsessMessage}
            />
          </React.Suspense>
        )}
      </div>
    </Modal>
  );
};
